import { Center, Flex } from '@libs/ui/ds'
import type { FC } from 'react'
import React from 'react'
import { useAuthorizedFeaturePolicies } from 'snap-redux/modules/countryConfigurations/selectors'

import { BirthdayCorner } from '../../../BirthdayCorner/BirthdayCorner'
import DaylightSavingTimeBadge from '../../../DaylightSavingTimeBadge/DaylightSavingTimeBadge'
import LockedContainer from '../../../LockedContainer'
import LockedIcon from '../../../LockedIcon'
import PublicHolidayBadge from '../../../PublicHolidayBadge'
import WeekCorner from '../../../WeekCorner/WeekCorner'
import { DayLabel } from '../../DayLabel/DayLabel'
import CreateNoteIcon from '../Aside/CreateNoteIcon/CreateNoteIcon'

import styles from './DayHeaderCell.module.css'

type Props = {
  weeklyscheduleId: number
  day: string
  index: number
  teamId: number
}

const DayHeaderCell: FC<Props> = ({ weeklyscheduleId, day, index, teamId }) => {
  const { authorizedPublicHolidays } = useAuthorizedFeaturePolicies()

  return (
    <Center className='group/day size-full'>
      <LockedContainer key={day} date={day}>
        {index === 0 && <WeekCorner date={day} />}
        <Center textCenter className='w-full gap-2'>
          <Flex row className='items-center gap-1'>
            <DayLabel date={day} />
            <LockedIcon date={day} />
          </Flex>
          <CreateNoteIcon
            className='hidden group-hover/day:block'
            weeklyscheduleId={weeklyscheduleId}
            dayDate={day}
          />
        </Center>
        {authorizedPublicHolidays && (
          <PublicHolidayBadge date={day} className={styles.BadgeContainer} />
        )}
        <DaylightSavingTimeBadge date={day} className={styles.BadgeContainer} />
        <BirthdayCorner teamId={teamId} day={day} />
      </LockedContainer>
    </Center>
  )
}

export default DayHeaderCell
